import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridFilterFormGroup } from './grid-filter-form-group';
import { GridFilterModel } from './grid-filter-model';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-grid-filter',
  styleUrls: ['./grid-filter.component.scss'],
  templateUrl: './grid-filter.component.html',
  imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, NgClass, MatIconButton, MatSuffix, MatTooltip, MatIcon],
})
export class GridFilterComponent implements OnChanges {
  // Determines if label of textfilter input should be accent or primary color
  @Input() public accentThemeFlag = true;
  @Input() public gridFilter: GridFilterModel;
  @Input() public matLabel = 'Rechercher dans la liste';
  @Input() public maxlength: number;
  @Output() public textFilterChangedEvent = new EventEmitter<string>();
  @ViewChild('_textFilterInput', { static: true }) private _textFilterInput: ElementRef;
  public formGroup: FormGroup<GridFilterFormGroup>;
  public textFilterAppliedFlag = false;

  public clear(): boolean {
    this.textFilterAppliedFlag = false;
    this.formGroup.controls.textFilter.setValue('');
    this.textFilterChangedEvent.emit('');

    // Don't submit a form if app-grid-filter is used inside a form
    return false;
  }

  public ngOnChanges(): void {
    if (!this.gridFilter) {
      this.gridFilter = new GridFilterModel('');
    }

    this._createForm();
    this.textFilterAppliedFlag = this.gridFilter.textFilter ? true : false;
  }

  public setFocus(): void {
    this._textFilterInput?.nativeElement?.focus();
  }

  public textFilterApplied(): boolean {
    this.textFilterChangedEvent.emit(this.formGroup.getRawValue().textFilter!);
    this.textFilterAppliedFlag = true;

    // Don't submit a form if app-grid-filter is used inside a form
    return false;
  }

  public textFilterChangedHandler(): void {
    this.textFilterAppliedFlag = false;
  }

  private _createForm(): void {
    this.formGroup = new FormGroup<GridFilterFormGroup>({
      textFilter: new FormControl<string>(this.gridFilter.textFilter!),
    });
  }
}
